var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","position":"relative"}},[_c('div',{staticClass:"nc-container",attrs:{"id":"your-dom-id"}})])}]

export { render, staticRenderFns }